import { z } from 'zod';
import { PointSchema } from './geojson';

/**
 * Legacy Phase A entity-level Camera schema. The platform now uses the
 * richer GeoJSON-feature shape from `./cameras.ts` for API responses;
 * this stays around for the original wiring test. New code should not
 * import these names.
 */
export const LegacyCameraStatusSchema = z.enum(['active', 'inactive']);
export type LegacyCameraStatus = z.infer<typeof LegacyCameraStatusSchema>;

export const CameraSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  location: PointSchema,
  headingDeg: z.number().min(0).max(360),
  fovDeg: z.number().positive().max(360),
  rangeM: z.number().positive(),
  streamUrl: z.string().url().optional(),
  status: LegacyCameraStatusSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Camera = z.infer<typeof CameraSchema>;
